import React from 'react';

import { Breadcrumb as AntBreadcrumb } from 'antd';
import styled from 'styled-components';

import useRecommendationsContext from './RecommendationsContext';
import DropdownLabel from '../lib/DropdownLabel';

const Breadcrumb = styled(AntBreadcrumb)`
  span {
    color: var(--text-primary);
  }
  li {
    display: flex;
    align-items: center;
  }
`;

const RecommendationCompanyBreadcrumb = () => {
  const { company, setCompany, companyOptions } = useRecommendationsContext();

  const handleSelect = (value: number) => {
    const selectedCompany = (companyOptions ?? []).find((option) => option.value === value);
    if (selectedCompany) {
      setCompany({
        id: selectedCompany.value as number,
        name: selectedCompany.label,
      });
    }
  };

  const options = companyOptions.map((option) => ({ id: option.value, name: option.label }));

  return (
    <Breadcrumb
      items={[
        {
          className: 'selector',
          title: <DropdownLabel selection={company?.id as number} options={options} onSelect={handleSelect} />,
        },
      ]}
      separator="·"
    />
  );
};

export default RecommendationCompanyBreadcrumb;
